var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.hasPromotionCardData
    ? _c("article", { staticClass: "nti-promotion" }, [
        _c("section", { staticClass: "nti-promotion__container" }, [
          _c("h2", { staticClass: "nti-promotion__title" }, [
            _vm._v(_vm._s(_vm.bestsellersTitle)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nti-promotion__card-container" },
            [
              _vm._l(_vm.bestsellersList, function (card, index) {
                return [
                  _c("BestSellerCard", {
                    key: index,
                    attrs: { card: card, label: _vm.label },
                  }),
                ]
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "nti-promotion__container" }, [
          _c("h2", { staticClass: "nti-promotion__title" }, [
            _vm._v(_vm._s(_vm.campaignTitle)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nti-promotion__card-container" },
            [
              _vm._l(_vm.campaignsList, function (card, index) {
                return [
                  _c("CampaignCard", {
                    key: index,
                    attrs: { card: card, label: _vm.label },
                  }),
                ]
              }),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }